module.exports = __webpack_public_path__ + "img/cog_blue.02f7d16f.png";